import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-select-state',
  templateUrl: './select-state.component.html',
styleUrls:  ['./select-state.component.css']
})
export class SelectStateComponent implements OnInit {

  @Input() selected_state: string;
  @Input() disabled: boolean;
  @Output() state_selected$: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  handleSelectionChange(){
  	this.state_selected$.next(this.selected_state);
  }

}
